import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { IAuthContext } from '../contexts/AuthContext';
// import { TanStackRouterDevtools } from '@tanstack/router-devtools';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

type RouterContext = {
  auth: IAuthContext;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="bg-stone-100">
      <Outlet />
      {import.meta.env.VITE_ENV === 'LOCAL' ||
        (import.meta.env.VITE_ENV === 'staging' && (
          <>
            {/* <TanStackRouterDevtools position="bottom-left" initialIsOpen={false} /> */}
            {/* <ReactQueryDevtools initialIsOpen={true} position="bottom" buttonPosition="bottom-right" /> */}
          </>
        ))}
    </div>
  );
}
